<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-door-open', fontSet: 'fad'}"
	[headerText]="'Station ' + (examStation.stationIndex + 1)"
	[matDialogData]="data"
	[rect]="rect"
	[showActionDivider]="false"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<section class="upper">
			<div class="stationIndex {{ SimStatusPalette.success }}">
				{{ examStation.stationIndex + 1 }}
			</div>

			<div class="stationInfo">
				<!--SCENARIO-->
				<label>{{ T.LABEL_SCENARIO | translate }} </label>
				@defer (when !isLoadingScenario()) {
					<!--TODO: Create Scenario Exam Info Dialog-->
					<button mat-button color="accent" [disabled]="true" (click)="openScenarioDetailDialog()">
						{{ examStation.scenarioName }}
					</button>
				} @loading (minimum 300ms) {
					<mat-spinner diameter="20" />
				}

				<!--ROOM-->
				<label> {{ T.LABEL_ROOM | translate }} </label>
				@defer (when !isLoadingRoom()) {
					<button mat-button color="accent" (click)="openTrainingRoomDetailDialog()">
						{{ examStation.trainingRoom.name }}
					</button>
				} @loading (minimum 300ms) {
					<mat-spinner diameter="20" />
				}
			</div>
		</section>

		@if (student || examiner || standardizedPatient) {
			<mat-divider />
		}

		<section class="participantInfo {{ phaseTheme() }}">
			<span class="headerLabelWrapper">
				<label> Help </label>
				<label> Ready </label>
			</span>
			<!--STUDENT-->
			@if (student) {
				<ng-container *ngTemplateOutlet="participant; context: {$implicit: student}" />
			}

			<!--EXAMINER-->
			@if (examiner) {
				<ng-container *ngTemplateOutlet="participant; context: {$implicit: examiner}" />
			}

			<!--SP-->
			@if (standardizedPatient) {
				<ng-container *ngTemplateOutlet="participant; context: {$implicit: standardizedPatient}" />
			}
		</section>
		<mat-divider />
	</ng-container>

	<ng-container actions>
		<sim-button
			(click)="close({action: 'cancel'})"
			(onClick)="close()"
			[icon]="{fontIcon: 'fa-check', fontSet: 'fa'}"
			[label]="T.BUTTON_CLOSE"
		/>
	</ng-container>
</sim-basic-material-dialog>

<!--PARTICIPANT ROW TEMPLATE-->
<ng-template #participant let-participant>
	<div class="participant">
		<div class="labelWrapper">
			@switch (data.participantState()[participant.participantType]) {
				@case (ExamParticipantDisplayState.Pending) {
					<div class="indicator inactive {{ SimStatusPalette.inactive }}">
						<ng-container *ngTemplateOutlet="participantIndicator; context: {$implicit: participant}" />
					</div>
				}
				@case (ExamParticipantDisplayState.Ready) {
					<div class="indicator {{ SimStatusPalette.success }}">
						<ng-container *ngTemplateOutlet="participantIndicator; context: {$implicit: participant}" />
					</div>
				}
				@case (ExamParticipantDisplayState.Help) {
					<div class="indicator {{ SimStatusPalette.warn }}">
						<ng-container *ngTemplateOutlet="participantIndicator; context: {$implicit: participant}" />
						<mat-icon class="helpBadge" fontIcon="fa-question-circle" fontSet="fas" />
					</div>
				}
			}
			<div class="description">
				<label>
					{{ participant.participantType | enumLabel: EnumLabel.ExamParticipant }}
				</label>
				<span>
					{{ participant.fullName }}
				</span>
			</div>
		</div>

		<span class="participantControls">
			<div class="controlWrapper">
				@if (!busyHelp().get(participant.participantType)) {
					<button
						(click)="resolveHelpRequest(participant)"
						[disabled]="data.participantState()[participant.participantType] !== ExamParticipantDisplayState.Help"
						class="helpBtn {{ SimStatusPalette.warn }}"
						mat-mini-fab
					>
						<mat-icon fontIcon="fa-hand-paper" fontSet="fas" />
					</button>
				} @else {
					<mat-spinner diameter="25" color="accent" />
				}
			</div>

			<div class="controlWrapper">
				@if (!busyReady().get(participant.participantType)) {
					<button
						(click)="toggleReady(participant)"
						[disabled]="data.examState() !== ExamApplicationDataType.StudentReady"
						color="accent"
						mat-mini-fab
					>
						<mat-icon
							[ngClass]="{
								'fa-lock-open': data.participantState()[participant.participantType] === ExamParticipantDisplayState.Ready,
								'fa-lock': data.participantState()[participant.participantType] !== ExamParticipantDisplayState.Ready,
							}"
							fontSet="fas"
						/>
					</button>
				} @else {
					<mat-spinner diameter="25" color="accent" />
				}
			</div>
		</span>
	</div>
</ng-template>

<!--PARTICIPANT INDICATOR TEMPLATE-->
<ng-template #participantIndicator let-participant>
	<i
		[ngClass]="{
			'fa-user-graduate': participant.participantType === ParticipantType.Learner,
			'fa-user-md': participant.participantType === ParticipantType.Instructor,
			'fa-user-injured': participant.participantType === ParticipantType.StandardizedPatient,
		}"
		class="fad"
	>
	</i>
	<span>{{ participant.authenticationCode }}</span>
</ng-template>
